export function groupApplicationDrafts(drafts) {
  const groups = [];
  const submitted = new Map();
  for (const draft of drafts) {
    const key = draft.status === "submitted" && typeof draft.application_id === "string" && draft.application_id.trim() ? draft.application_id : null;
    if (!key || !submitted.has(key)) {
      const entry = { ...draft, relatedDrafts: [] };
      groups.push(entry);
      if (key) submitted.set(key, entry);
    } else {
      submitted.get(key).relatedDrafts.push(draft);
    }
  }
  return groups;
}
